/* eslint-disable react/prop-types */
/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect, ReactElement } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import {
  getHTPPErrorInfoEvent,
  storeHTPPErrorInfoEvent,
} from '@/store/commonDuck/NotificationDuck';
import {
  HTTPErrorInfoEventType as EventType,
  Store,
  HTTPErrorInfoEvent,
} from '@/types';
import serverErrorSVG from '@/assets/images/server_error.svg';
import networkErrorSVG from '@/assets/images/network_error.svg';

import { Button } from '@/components/uikit';
import { Grid } from '@material-ui/core';
import { useTranslate } from '@/locale';
import Dialog from './Dialog';

interface HTTPErrorInfoDialogProps {
  httpErrorInfoEvent: HTTPErrorInfoEvent;
  storeHTPPErrorInfoEventLocal: (payload: HTTPErrorInfoEvent) => void;
}

const InternalServerError: () => ReactElement = () => {
  const reload = () => {
    window.location.reload();
  };
  return (
    <Grid
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Grid style={{ display: 'flex' }}>
        <img width="160px" src={serverErrorSVG} alt="" />
      </Grid>
      <Grid
        style={{
          display: 'flex',
          textAlign: 'center',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <h3 style={{ marginBottom: 'unset' }}>Sorry, it's not you, it's us.</h3>
        <p
          style={{
            fontSize: '14px',
            paddingLeft: '10px',
            paddingRight: '10px',
          }}
        >
          We're experiencing an internal server problem. Please try again later
        </p>
        <Button style={{ borderRadius: '10px', width: '80%' }} onClick={reload}>
          Reload
        </Button>
      </Grid>
    </Grid>
  );
};

const SelectedDeliveryCostNotFound: (props: {
  closeDialog: () => void;
}) => ReactElement = props => {
  const { closeDialog } = props;
  const { translate } = useTranslate();
  return (
    <Grid
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Grid style={{ display: 'flex' }}>
        <img width="160px" src={serverErrorSVG} alt="" />
      </Grid>
      <Grid
        style={{
          display: 'flex',
          textAlign: 'center',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <h3 style={{ marginBottom: 'unset' }}>
          {translate('errorTitleCheckOutNoDeliveryOption')}
        </h3>
        <p
          style={{
            fontSize: '14px',
            paddingLeft: '10px',
            paddingRight: '10px',
          }}
        >
          {translate('errorMessageCheckOutNoDeliveryOption')}
        </p>
        <Button
          style={{ borderRadius: '10px', width: '80%' }}
          onClick={closeDialog}
        >
          Try Again
        </Button>
      </Grid>
    </Grid>
  );
};

type NetworkErrorProps = HTTPErrorInfoDialogProps;

const NetworkError: (props: NetworkErrorProps) => ReactElement = props => {
  const closeDialog = () => {
    window.location.reload();
  };
  return (
    <Grid
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Grid style={{ display: 'flex' }}>
        <img width="160px" src={networkErrorSVG} alt="" />
      </Grid>
      <Grid
        style={{
          display: 'flex',
          textAlign: 'center',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <h3 style={{ marginBottom: 'unset' }}>You are not connected</h3>
        <p
          style={{
            fontSize: '14px',
            paddingLeft: '10px',
            paddingRight: '10px',
          }}
        >
          Please check your internet connection and then try again
        </p>
        <Button
          style={{ borderRadius: '10px', width: '80%' }}
          onClick={closeDialog}
        >
          Try Again
        </Button>
      </Grid>
    </Grid>
  );
};

const SubscriptionNotFoundError: () => ReactElement = () => {
  const reload = () => {
    window.location.reload();
  };
  return (
    <Grid
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Grid
        style={{
          display: 'flex',
          textAlign: 'center',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <h3 style={{ marginBottom: 'unset' }}>Please check again.</h3>
        <p
          style={{
            fontSize: '14px',
            paddingLeft: '10px',
            paddingRight: '10px',
          }}
        >
          Subscription not found.
        </p>
        <Button style={{ borderRadius: '10px', width: '80%' }} onClick={reload}>
          Reload
        </Button>
      </Grid>
    </Grid>
  );
};

type RenderChild = {
  [key in EventType]: () => ReactElement;
};

const HTTPErrorInfoDialog = (props: HTTPErrorInfoDialogProps) => {
  const { storeHTPPErrorInfoEventLocal, httpErrorInfoEvent } = props;
  const closeDialog = () => {
    storeHTPPErrorInfoEventLocal({
      isOpen: false,
      type: httpErrorInfoEvent.type,
    });
  };
  const renderChild: RenderChild = {
    INTERNAL_SERVER_ERROR: () => <InternalServerError />,
    NETWORK_ERROR: () => (
      <NetworkError
        storeHTPPErrorInfoEventLocal={storeHTPPErrorInfoEventLocal}
        httpErrorInfoEvent={httpErrorInfoEvent}
      />
    ),
    SUBSCRIPTION_NOT_FOUND: () => <SubscriptionNotFoundError />,
    SELECTED_DELIVERY_COST_NOT_FOUND: () => (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <SelectedDeliveryCostNotFound closeDialog={closeDialog} />
    ),
  };
  return (
    <Dialog open={httpErrorInfoEvent.isOpen}>
      {renderChild[httpErrorInfoEvent.type]
        ? renderChild[httpErrorInfoEvent.type]()
        : null}
    </Dialog>
  );
};

const mapStateToProps = (state: Store) => {
  return {
    httpErrorInfoEvent: getHTPPErrorInfoEvent(state),
  };
};

const mapActionToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    { storeHTPPErrorInfoEventLocal: storeHTPPErrorInfoEvent },
    dispatch
  );
};

export default connect(mapStateToProps, mapActionToProps)(HTTPErrorInfoDialog);
